export const REQUEST_GET_REFERRERS = 'REQUEST_GET_REFERRERS';
export const RECEIVE_GET_REFERRERS = 'RECEIVE_GET_REFERRERS';
export const RECEIVE_GET_REFERRERS_ERROR = 'RECEIVE_GET_REFERRERS_ERROR';
